export const tailwindClassnames = {
  appContainer:
    "App bg-primary-off-white dark:bg-deepBlue-dark transition duration-300",

  tableTitle:
    "text-deepBlue dark:text-sky-blue-light font-medium text-4xl transition duration-300",
  tableHead:
    "bg-tealBlue-300 text-left border border-2 border-off-white-dark border-b-deepBlue-light ",
  tableHeadText: "py-2 px-4 font-medium",
  tableBody: " cursor-pointer border-b border-b-off-white-dark ",
  tableBodyText:
    "text-primary-off-black text-md py-2 px-4 text-left overflow-hidden text-ellipsis whitespace-nowrap max-w-xs",
  tableBodyButton:
    "text-center text-primary-off-black dark:text-primary-off-white transition duration-300",
  sortingArrows: "text-sky-blue-dark",
  tableContainer: " text-left w-full my-3 shadow",

  lookupButton:
    "py-2 bg-tealBlue-300 rounded px-4 font-light text-primary-off-black dark:text-primary-off-white transition duration-300 text-center",
  addButton:
    "bg-sky-blue text-deepBlue font-medium py-2 px-4 rounded shadow shadow-off-white-dark dark:shadow-deepBlue ml-3 transition duration-300",
  searchButton:
    "py-2 bg-tealBlue-300 rounded px-4 font-light text-primary-off-black text-center ml-2",
  searchTextInput:
    "p-2 w-full rounded text-primary-off-black bg-primary-off-white border border-off-white-dark placeholder-off-black-light text-sm",
  saveButton:
    "bg-sky-blue text-deepBlue font-bold py-2 px-4 rounded shadow-sm shadow-off-white-dark dark:shadow-deepBlue-dark ml-4 transition duration-300",
  disabledSaveButton:
    "bg-sky-blue-dark text-deepBlue-light font-bold py-2 px-4 rounded ml-4",
  cancelButton:
    "bg-deepBlue-light text-sky-blue font-bold py-2 px-4 rounded shadow-sm shadow-off-white-dark dark:shadow-deepBlue-dark transition duration-300",
  decommissionButton:
    "bg-deepBlue text-sky-blue font-bold py-2 px-4 rounded shadow-sm shadow-deepBlue-dark ml-4",
  disabledCancelButton:
    "bg-deepBlue text-deepBlue-light font-bold py-2 px-4 rounded ml-4",
  disabledAddButton:
    "bg-sky-blue-dark text-deepBlue-light font-medium py-2 px-4 rounded shadow shadow-deepBlue",

  textInputLabel:
    "mb-1 text-off-black-light dark:text-primary-off-white text-sm font-light transition duration-300",
  textInputLabelDisabled: "mb-1 text-greyed-text text-sm font-light",
  textInputSearch:
    "p-2 w-52 rounded text-primary-off-black dark:text-off-white-dark bg-primary-off-white border border-off-white-dark dark:border-off-black-light dark:bg-deepBlue w-full placeholder-off-black-light text-sm transition duration-300",
  dateRangeSearchInput:
    "bg-off-white-dark p-2 w-60 rounded shadow placeholder-off-black-light text-primary-off-black text-sm",
  checkBoxLabel:
    "text-primary-off-black dark:text-primary-off-white text-sm font-light inline-block mx-2 transition duration-300",
  checkBox:
    "mt-1 accent-deepBlue dark:accent-sky-blue cursor-pointer transition duration-300",

  warningLabel:
    "text-orange-200 rounded-sm font-bold bg-orange-700 px-2 py-1 text-sm",
  warningHeader:
    "text-orange-700 dark:text-orange-200 rounded-sm font-bold bg-orange-200 dark:bg-orange-700 px-2 py-1 text-lg transition duration-300",
  basicLabel:
    "text-primary-off-black dark:text-primary-off-white text-sm font-light mb-3 transition duration-300",
  dropdownLabel:
    "text-off-black-light dark:text-primary-off-white text-sm font-light mb-1",
  basicSubHeading:
    "text-deepBlue dark:text-sky-blue-light text-left text-2xl font-light mb-2 mt-6 transition duration-300",

  formSection:
    "flex flex-wrap shadow border border-primary-off-white dark:border-deepBlue transition duration-300 p-3 m-3 rounded-sm",
  detailsPageTitle:
    "text-deepBlue dark:text-sky-blue-light font-medium text-left text-4xl mb-2 transition duration-300",
  detailsPageTextInputContainer: "w-full md:w-1/2 px-3 mb-6 md:mb-0",
  detailsPageTextInput:
    "rounded px-3 py-2 text-primary-off-black dark:text-off-white-dark bg-primary-off-white border border-off-white-dark dark:border-off-black-light dark:bg-deepBlue w-full placeholder-off-black-light transition duration-300",
  detailsPageTextInputDisabled:
    "rounded px-3 py-2 text-off-black-light dark:text-greyed-text bg-off-white-dark dark:bg-deepBlue w-full placeholder-greyed-text",
  detailsPageTextArea:
    "rounded px-3 py-2 text-primary-off-white bg-primary-off-white dark:bg-deepBlue border border-off-white-dark dark:border-off-black-light w-full h-48 placeholder-deepBlue-light",
  detailsPageTextAreaDisabled:
    "rounded px-3 py-2 text-deepBlue-light bg-deepBlue w-full h-48 placeholder-deepBlue-light",

  detailsActiveTab:
    "bg-off-white-dark dark:bg-deepBlue-light text-deepBlue dark:text-primary-off-white font-medium pt-2 pb-1 mb-1 px-4 border border-x-off-white-dark border-t-off-white-dark border-b-deepBlue dark:border-x-deepBlue-light dark:border-t-deepBlue-light dark:border-b-sky-blue transition duration-300",
  detailsInactiveTab:
    "text-deepBlue-dark dark:text-off-white-dark font-medium pt-2 pb-1 mb-1 px-4 transition duration-300",

  modalContainer:
    "z-50 fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center max-h-full overflow-y-auto",
  modalHeader:
    "text-center font-medium text-deepBlue dark:text-primary-off-white text-2xl pb-0 transition duration-300",
  modalBackground:
    "bg-primary-off-white dark:bg-deepBlue-light rounded text-left p-8 min-w-[300px] space-y-4 translate-y-20 transition duration-300",
  formBackground:
    "bg-primary-off-white dark:bg-deepBlue-dark rounded text-left p-8 min-w-[300px] w-1/2 space-y-4 translate-y-10",

  paginationContainer:
    "fixed bottom-0 left-48 right-8 px-3 pt-3 flex flex-row justify-between bg-primary-off-white/50 dark:bg-deepBlue/50 backdrop-blur-sm  transition duration-300",

  noHover: "cursor-default",

  stormBlue: "#272837",
  skyBlue: "#B0E6FA",
  greyedText: "#999999",
  stormBlueLight: "#6E6E7F",
  primaryOffWhite: "#EDEDED",
  offBlackLight: "#626262",
};

export default tailwindClassnames;
